import { createSlice } from "@reduxjs/toolkit";
import { getUserWallet } from "../thunks/userThunk";

const userSlice = createSlice({
    name: "user",
    initialState:{
        wallet: {},
        isWalletFetching: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserWallet.fulfilled, (state, action) => {
                state.wallet = action.payload.data
                state.isWalletFetching = false
            })
            .addCase(getUserWallet.pending, (state, action) => {
                state.isWalletFetching = true
            })
            .addCase(getUserWallet.rejected, (state, action) => {
                state.isWalletFetching = false
            })

    }
})

export default userSlice.reducer